import {
  PAGE_TYPE_CATEGORY,
  PAGE_TYPE_SEARCH_RESULTS,
  TENANT_COM,
} from 'shared/consts'
import {
  CAT_ADD_TO_CART_CLICK,
  SERP_ADD_TO_CART_CLICK,
  SERP_REMOVE_ADD_TO_CART_CTA_COM,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'
import type { PageType } from 'types/cmsTypes'

const isEnvValid = (
  containers: NodeListOf<HTMLElement>,
  pageType: PageType,
  searchUrl: string | undefined
): boolean => {
  const { isEnabled } = getExperimentOnClient(SERP_REMOVE_ADD_TO_CART_CTA_COM)
  const { tenant } = store.getPublicRuntimeConfig()?.publicConfig || {}

  return Boolean(
    isEnabled &&
      tenant === TENANT_COM &&
      (pageType === PAGE_TYPE_SEARCH_RESULTS ||
        (pageType === PAGE_TYPE_CATEGORY &&
          searchUrl?.includes('all-from-category'))) &&
      containers.length > 0
  )
}

export default () => {
  const addToCartContainers = document.querySelectorAll<HTMLElement>(
    '.o-SearchProductListItem__content__buy-section__cart-section'
  )
  const { pageType = '', searchUrl } =
    store.getPublicRuntimeConfig()?.pageProperties || {}

  if (!isEnvValid(addToCartContainers, pageType, searchUrl)) {
    return
  }

  void activateExperiment(SERP_REMOVE_ADD_TO_CART_CTA_COM)

  addToCartContainers?.forEach((singleAddToCartContainer: HTMLElement) => {
    singleAddToCartContainer.addEventListener('click', element => {
      const target = <HTMLElement>element.target

      if (
        target.closest('[data-clientside-hook~="add2CartForm"] [type=submit]')
      ) {
        if (pageType === PAGE_TYPE_SEARCH_RESULTS) {
          trackEvent(SERP_ADD_TO_CART_CLICK)
        }
        if (pageType === PAGE_TYPE_CATEGORY) {
          trackEvent(CAT_ADD_TO_CART_CLICK)
        }
      }
    })
  })
}
